module.exports = __webpack_public_path__ + "static/media/slide-image-2-small-min-new.11383e7a.jpg";